module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/66a613e869e2913719f14338b88ef84d.png";